import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';

function GreatEmoji() {
  return (
    <InsertEmoticonIcon
      style={{
        border: '1px solid black',
        color: 'black',
        background: '#00FF00',
        fontSize: '36px',
      }}
    />
  );
}

export default GreatEmoji;
